import { render, staticRenderFns } from "./Shifts.vue?vue&type=template&id=ebb66fd6&"
import script from "./Shifts.vue?vue&type=script&lang=ts&"
export * from "./Shifts.vue?vue&type=script&lang=ts&"
import style0 from "./Shifts.vue?vue&type=style&index=0&id=ebb66fd6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports